import { Popup } from "@progress/kendo-react-popup";
import * as React from "react";
import { useRef, useState } from "react";
import { IConfig } from "../../../Config";

interface IProps {
    renderFiltersForCategories: () => JSX.Element;
    renderFiltersForTags: () => JSX.Element;
}

const Filter = (props: IProps) => {
    const [showFilterPopup, setShowFilterPopup] = useState(false);

    const filterPopupAnchor = useRef<HTMLButtonElement>(null);

    return (
        <>
            <button
                className="k-button"
                onClick={(e) => {
                    e.preventDefault();
                    setShowFilterPopup(!showFilterPopup);
                }}
                ref={(button) => filterPopupAnchor.current = button}
            >
                <em className="fa fa-filter" title="Filter"></em>
            </button>
            <Popup
                animate={false}
                anchor={filterPopupAnchor.current}
                show={showFilterPopup}
                popupClass={"popup-content"}
                anchorAlign={{
                    horizontal: "right",
                    vertical: "bottom",
                }}
                popupAlign={{
                    horizontal: "right",
                    vertical: "top",
                }}
            >
                <div className="CMS_e_row">
                    <div className="NR_tags">
                        <div className="CMS_title CMS_T5">
                            <em className="fa fa-th-large"></em> Categories
                        </div>
                        {props.renderFiltersForCategories()}
                    </div>
                </div>
                <div className="CMS_e_row">
                    <div className="NR_tags">
                        <div className="CMS_title CMS_T5">
                            <em className="fa fa-tags"></em> Tags
                        </div>
                        {props.renderFiltersForTags()}
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default Filter;
